//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyLoad from 'vanilla-lazyload'
const VIDEO_EXTENSIONS = ['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4']
const IMAGE_EXTENSIONS = ['.gif', '.jpg', '.jpeg', '.png']
import VideoControls from '@/elements/editorial/video/video-controls.vue'

export default {
  name: 'rb-lazy-media',
  extends: VideoControls,
  props: {
    preventLoading: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    controls: {
      type: Boolean,
      default: true,
    },
    controlsTheme: {
      type: String,
      default: 'dark',
    },
    poster: {
      type: String,
      default: '',
    },
    fetchpriority: {
      type: String,
      default: 'auto',
    },
    decoding: {
      type: String,
      default: 'async',
    },
    loop: {
      type: Boolean,
      default: true,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    forceLoad: {
      type: Boolean,
      default: false,
    },
    noPointerEventImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialized: false,
      loading: true,
    }
  },
  computed: {
    isImage() {
      return IMAGE_EXTENSIONS.some((extension) => this.src?.includes(extension))
    },
    isVideo() {
      return VIDEO_EXTENSIONS.some((extension) => this.src?.includes(extension))
    },
    playClass() {
      const playIcon = this.controlsTheme === 'dark' ? 'vp-play-round-dark' : 'vp-play-round'
      return `common__icon--${playIcon}`
    },
    pauseClass() {
      const pauseIcon = this.controlsTheme === 'dark' ? 'vp-pause-round-dark' : 'vp-pause-round'
      return `common__icon--${pauseIcon}`
    },
    isCustomElementImage() {
      return !!this.$slots['custom-element-image'] && this.loading
    },
  },
  watch: {
    src() {
      this.$nextTick(() => {
        if (!this.preventLoading && this.initialized) {
          this.lazyLoadMedia()
        }
      })
    },
    preventLoading(newVal) {
      if (!newVal) {
        this.lazyLoadMedia()
      }
    },
  },
  mounted() {
    if (!this.preventLoading) {
      this.onViewportIntersection()
    }
    if (this.forceLoad) {
      this.lazyLoadMedia()
    }
  },
  methods: {
    onViewportIntersection(e) {
      if (!this.initialized && (e?.type === 'enter' || e?.type === 'progress')) {
        if (!this.preventLoading) {
          this.lazyLoadMedia()
        }
      }
    },
    getRef() {
      return this.isVideo ? this.$refs.video : this.$refs.image
    },
    lazyLoadMedia() {
      this.initialized = true
      this.loading = true
      LazyLoad.load(this.getRef(), {
        callback_loading: () => {
          this.$emit('loading')
        },
        callback_loaded: () => {
          this.loading = false
          this.$emit('loaded')
          if (this.isVideo) {
            this.play()
            this.removeSrcFromSource()
          }
        },
      })
    },
    removeSrcFromSource() {
      const source = this.getRef().querySelector('source')
      if (source.dataset.src) {
        source.removeAttribute('data-src')
      }
    },
  },
}
